export const SET_MOXTRA_SCHEDULED_MEETINGS = "SET_MOXTRA_SCHEDULED_MEETINGS";
export const FETCHING_MOXTRA_SCHEDULED_MEETINGS = "FETCHING_MOXTRA_SCHEDULED_MEETINGS"
